const html = `
    <div class="footer-links">
        <div class="footer-links-col ___desktop-50">
            <div class="footer-logos-info">
                <h2 class="screen-reader-text">Colophon</h2>
                Curaçao Health App is developed by the Ministry of Health, Environment and Nature (GMN).
                This application was created with the help of experience experts.
                A large open source community also watched and tested during the development.
            </div>
        </div>
        <div class="footer-links-col ___desktop-50">
            <h2>Do you have Questions?<br>
            Contact us
            </h2>
            <h3>Call the helpdesk</h3>
            <p><a href="tel:433-3111">433-3111</a><br />
            Available from Monday to Friday from 8 a.m. – 3 p.m.</p>
            <h3>Or send an email to:</h3>
            <p>
                <a href="mailto:helpdesk@curacaohealthapp.com" target="_blank" rel="noopener noreferrer">helpdesk@curacaohealthapp.com</a>
            </p>
        </div>
        <div style="position: relative;height:400px;width: 300px;">
            <div style="margin: 0;position:absolute; top:50%;left: 50%;">
                <img style="alignment: right;" src="assets/img/artwork/CHA_app_Graphics-16.png" width=182 height=100 />
            </div>
        </div>
    </div>
`;

export default html
